import type { ReactNode } from 'react';
import { useState } from 'react';
import Confirm from './Confirm';

export interface ConfirmTriggerProps {
  title: string;
  description: ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  trigger: (props: { setIsOpen: (isOpen: boolean) => void }) => ReactNode;
  type?: 'warn' | 'success' | 'error' | 'info' | 'danger' | 'default';
  size?: 'sm' | 'md' | 'lg';
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const ConfirmTrigger = ({
  title,
  description,
  isDisabled,
  onConfirm,
  onCancel,
  trigger,
  type = 'warn',
  size = 'md',
  isLoading,
}: ConfirmTriggerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open && onCancel) {
      onCancel();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  const _handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setIsOpen(true);
    }
  };

  const _handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isDisabled || isLoading) return;
    setIsOpen(true);
  };

  return (
    <>
      {/* <button
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        type='button'
        aria-label={title}
        className='border-none bg-transparent p-0 cursor-pointer'
      > */}
      {trigger({ setIsOpen })}
      {/* </button> */}
      <Confirm
        title={title}
        message={description}
        isOpen={isOpen}
        onConfirm={handleConfirm}
        onOpenChange={handleOpenChange}
        type={type}
        size={size}
        isLoading={isLoading}
      />
    </>
  );
};

export default ConfirmTrigger;
